import { smsTemplateSchema } from "@redotech/redo-model/sms-template";
import * as z from "zod/v4";

export const createSmsTemplate = {
  name: "createSmsTemplate" as const,
  input: z.object({ template: smsTemplateSchema.omit({ _id: true }) }),
  output: smsTemplateSchema,
};
